import * as yup from "yup";

export const newNotiTypeSchema = yup.object().shape({
  notiTypeName: yup
    .string()
    .min(2, "A név minimum 2 karakter hosszú kell legyen")
    .max(200, "A név maximum 200 karakter lehet")
    .required("A név megadása kötelező"),
});
